import { t } from '@lingui/macro';
import { useAtom } from 'jotai';
import React, { memo } from 'react';

import LoadableContent from '../../components/content/LoadableContent';
import CustomerForm from '../../components/customerform/CustomerForm';
import InterventionPage from '../../components/page/InterventionPage';
import { jobDetailsWithHousePropertiesPhotosAndStateAtom } from '../../store/Atoms';

const TabSignature: React.FC = memo(() => {
    const [value] = useAtom(jobDetailsWithHousePropertiesPhotosAndStateAtom);

    return (
        <InterventionPage title={t`Signature`} withPadding>
            <LoadableContent value={value}>
                <CustomerForm />
            </LoadableContent>
        </InterventionPage>
    );
});

export default TabSignature;
